import { US_STATES } from '@app/shared';
import type { CarrierDto } from '@app/shared';
import type { Option } from '../../components/form';

/** Option lists shared by the Plan Config filters and forms. */

export const STATE_OPTIONS: Option[] = US_STATES.map(([code, name]) => ({
  value: code,
  label: `${name} [${code}]`,
}));

/** The reference lists carriers by their code (e.g. `TMB`). */
export const carrierOptions = (carriers: CarrierDto[] | undefined): Option[] =>
  (carriers ?? []).map((c) => ({ value: c.id, label: c.code }));

/** Keeps a select's saved value selectable while its options load or after it stopped being offered. */
export const withCurrent = (options: Option[], current: Option | undefined): Option[] =>
  !current || options.some((o) => o.value === current.value) ? options : [...options, current];
